import { Tooltip, TooltipProps } from '@systemeio/ui'
import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

// show tooltip if part of text is hidden
export const TextWithTooltipCell = ({
  children,
  label,
  wrapperClassName,
  textClassName,
  mode = 'overflow',
}: {
  children: ReactNode
  label?: string
  wrapperClassName?: string
  textClassName?: string
  mode?: TooltipProps['mode']
}) => {
  return (
    <Tooltip
      mode={mode}
      wrapperClassName={wrapperClassName}
      className={'flex items-center'}
      label={
        label ||
        (typeof children == 'string' || typeof children == 'number' ? String(children) : '')
      }
    >
      <span className={twMerge('inline-block w-full truncate', textClassName)}>{children}</span>
    </Tooltip>
  )
}
